import { render, staticRenderFns } from "./PackageSettingCreateType.vue?vue&type=template&id=6048f910"
import script from "./PackageSettingCreateType.vue?vue&type=script&lang=js"
export * from "./PackageSettingCreateType.vue?vue&type=script&lang=js"
import style0 from "./PackageSettingCreateType.vue?vue&type=style&index=0&id=6048f910&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports